import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Legend,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Legend, Tooltip);

function Linechart({ influencer_trending, filter }) {
    const { t } = useTranslation();
    const [lineChartData, setLineChartData] = useState(null);
    const [lineChartOptions, setLineChartOptions] = useState(null);
    
    useEffect(() => {
        if (!influencer_trending) return;

        const videoData = influencer_trending.filter(d => d.legend === "Video Influencers");
        const liveData = influencer_trending.filter(d => d.legend === "Live Influencers");
        const labels = videoData.map(d => d.axis_x);

        setLineChartData({
            labels,
            datasets: [
                {
                    label: "Video Influencers",
                    data: videoData.map(d => d.axis_y),
                    borderColor: "#4F70FD",
                    backgroundColor: "#4F70FD",
                    tension: 0.3,
                    yAxisID: "y",
                    pointRadius: 0,
                    pointHoverRadius: 4,
                },
                {
                    label: "Live Influencers",
                    data: liveData.map(d => d.axis_y),
                    borderColor: "#E04ACB",
                    backgroundColor: "#E04ACB",
                    tension: 0.3,
                    yAxisID: "y1",
                    pointRadius: 0,
                    pointHoverRadius: 4,
                },
            ],
        });

        setLineChartOptions({
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                },
                tooltip: {
                    mode: "index",
                    intersect: false,
                },
                datalabels: { display: false },
                title: {
                    display: true,
                    text: `${t("Related Influencers Trends")} (${(filter.dateRange || "30") + " days"})`,
                },
            },
            interaction: {
                mode: "nearest",
                intersect: false,
            },
            scales: {
                y: {
                    type: "linear",
                    position: "left",
                    ticks: {
                        callback: (value) => `${(value / 1000).toFixed(1)}K`,
                    },
                    title: {
                        display: true,
                        text: "Video Influencers",
                    },
                },
                y1: {
                    type: "linear",
                    position: "right",
                    grid: {
                        drawOnChartArea: false,
                    },
                    ticks: {
                        callback: (value) => `${(value / 1000).toFixed(1)}K`,
                    },
                    title: {
                        display: true,
                        text: "Live Influencers",
                    },
                },
            },
        });
    }, [influencer_trending, filter, t]);

    return (
        <Fragment>
            {lineChartData && lineChartOptions && (
                <Line type="bar" data={lineChartData} options={lineChartOptions} />
            )}
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Linechart);